import React from 'react';
import PropTypes from 'prop-types';
import * as Actions from 'actions';
import { connect } from 'react-redux';
import { Collapse } from 'react-bootstrap';
import { Checkbox } from 'components';

class FilterGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open : false,
    }
    this.toggleMenu = this.toggleMenu.bind(this);
  }
  toggleMenu() {
    this.setState({ open : !this.state.open })
  }
  render() {
    const {current, available, title} = this.props;
    const { open } = this.state;
    const count = current.length;
    return (
      <li onClick={this.toggleMenu}>
      	<div className='col-md-6 col-xs-6'>
        <span className="title" style={{textTransform : 'capitalize'}}>{title}</span>
        </div>
        <span className={`count ${count == 0 ? 'none' : ''}`}>{count} selected</span>
        <span className="pull-right"><i className={`fa fa-${open ? 'caret-down' : 'caret-left'}`}></i></span>
        <Collapse onClick={e => e.stopPropagation()} in={open}>
          <div className="content">
            {available.map((filter, index) =>
              <Checkbox
                id={`${filter.value}-${index}`}
                key={`${filter.value}-${index}`}
                checked={current.find(({ value }) => value == filter.value) ? true : false}
                onChange={() => this.props.onChange(filter)}
                label={filter.value}
              />
            )}
          </div>
        </Collapse>
      </li>
    )
  }
}

class JobFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filters : [],
      open : []
    }
  }
  componentWillMount() {
    this.props.fetchJobsFilters();
  }
  groupFilters(current_filters, available_filters) {
    const filters = {
      available : {},
      current : {},
    }

    available_filters.forEach(filter => {
      if(!filters.available[filter.type]) {
        filters.available[filter.type] = [];
      }
      if(!filters.current[filter.type]) {
        filters.current[filter.type] = [];
      }

      filters.available[filter.type].push(filter)
    });

    current_filters.forEach(filter => {
      if(!filters.current[filter.type]) {
        filters.current[filter.type] = [];
      }

      filters.current[filter.type].push(filter)
    });

    return filters;
  }
  render() {
    const { current_filters, available_filters } = this.props;
    const { current, available } = this.groupFilters(current_filters, available_filters);

    return <div className="job-filter">
      <ul className="list-unstyled">
        {Object.getOwnPropertyNames(available).map((type, index) =>
          <FilterGroup
            key={index}
            title={type.replace('_',' ')}
            current={current[type]}
            available={available[type]}
            onChange={filter => {
              this.props.toggleJobsFilter(filter);
              this.props.fetchJobs();
            }}
          />
        )}
      </ul>
    </div>
  }
}

const mapStateToProps = ({ jobs }) => ({ ...jobs });

export default connect(mapStateToProps,Actions)(JobFilter);



// WEBPACK FOOTER //
// ./src/browser/components/client/jobs/job-filter.js